import { ReactComponent as MainLogo } from '../../../assets/logo/main-logo.svg';
import { ReactComponent as MainTitleLogo } from '../../../assets/logo/main-title-logo.svg';
import UserBox from '../../ui/user-box/user-box.component';
import {
    CustomAppBar,
    CustomToolBar,
    CustomToolBarLeftBox,
    CustomToolBarMiddleBox,
    CustomToolBarRightBox,
} from './top-bar.styles';

const TopBar = () => {
    return (
        <CustomAppBar position="static" sx={{ py: 3 }}>
            <CustomToolBar>
                <CustomToolBarLeftBox>
                    <MainLogo />
                </CustomToolBarLeftBox>
                <CustomToolBarMiddleBox>
                    <MainTitleLogo />
                </CustomToolBarMiddleBox>
                <CustomToolBarRightBox>
                    <UserBox />
                </CustomToolBarRightBox>
            </CustomToolBar>
        </CustomAppBar>
    );
};

export default TopBar;
